.mapboxgl-ctrl-geocoder {
    width: 100%;
    border: 1px solid #d9d9d9;
    box-shadow: none;
    margin-bottom: 2em;
}

#jobsite-geocoder-container > .mapboxgl-ctrl-geocoder--input {
    color: white;
}
@media screen and (min-width: 640px) {
    .mapboxgl-ctrl-geocoder {
        max-width: 100%;
    }
}
